import { render, staticRenderFns } from "./internalResourceVideo1.vue?vue&type=template&id=0c4220fb&scoped=true"
import script from "./internalResourceVideo1.vue?vue&type=script&lang=js"
export * from "./internalResourceVideo1.vue?vue&type=script&lang=js"
import style0 from "./internalResourceVideo1.vue?vue&type=style&index=0&id=0c4220fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4220fb",
  null
  
)

export default component.exports